<template>
  <div v-if="currentTraining != null">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-body">
            <div class="box-group" id="accordion">
              <div class="panel box box-primary">
                <div class="box-header with-border">
                  <h4 class="box-title">
                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseHelpAdditionalService"
                       aria-expanded="false"
                       class="collapsed">
                      {{$t('help.title')}}
                    </a>
                  </h4>
                </div>
                <div id="collapseHelpAdditionalService" class="panel-collapse collapse" aria-expanded="false"
                     style="height: 0px;">
                  <div v-if="$root.$i18n.locale == 'en'" class="box-body">
                    <p>If you offer participants any additional service (-s) (not covered by the program’s cost
                      by “default”), - you can add it here.</p>

                    <p><b>Example</b><br> (a): English language classes (40 academic hours) - 250 USD;
                      <br>(b) Cancellation insurance - 50 USD;
                      <br>etc.</p>

                    <p>We encourage Sports Program Providers to approach this option very diligently and not
                      abuse it. If some additional service does not need to be prepaid and scheduled in advance
                      (e.g., rent of the equipment), - please, do not offer it on the platform.</p>

                  </div>
                  <div v-if="$root.$i18n.locale == 'ru'" class="box-body">
                    <p>Если Организатором предлагается какая-то дополнительная платная услуга (не входит в
                      базовый
                      “пакет” и стоимость спортивной программы) - то ее можно здесь указать.</p>

                    <p><b>Примеры:</b><br> (а) Курс английского языка, 20 академических часов - 10 000 руб.
                      <br>(б) Дополнительные индивидуальные занятия с тренером [Имя], 10 часов - 10 000 руб.</p>

                    <p>Просим ответственно относиться к данной возможности и указывать только существенные
                      услуги.
                      Те услуги, которые проще заказать на месте и не требуют планирования (например, аренда
                      инвентаря) - не предлагать к бронированию на платформе.</p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="box box-success">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.additional-service.active-additional-services')}}</h3>
          </div>
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <tbody>
              <tr>
                <th>{{$t('trainings.additional-service.name')}}</th>
                <th v-if="isBackoffice()">{{$t('trainings.additional-service.name')}} [ru]</th>
                <th>{{$t('trainings.additional-service.price')}}</th>
                <th></th>
              </tr>
              <tr
                v-for="additionalService in currentTraining.additionalServices"
                :key="additionalService.id">
                <td v-if="!isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="additionalService.name[$root.$i18n.locale]" class="form-control">

                    <span class="input-group-btn">
                    <button v-on:click="updateAdditionalService(additionalService)" type="button" class="btn btn-info btn-flat">Save</button>
                  </span>
                  </div>
                </td>
                <td v-if="isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="additionalService.name['en']" class="form-control">

                    <span class="input-group-btn">
                    <button v-on:click="updateAdditionalService(additionalService)" type="button" class="btn btn-info btn-flat">Save</button>
                  </span>
                  </div>
                </td>
                <td v-if="isBackoffice()">
                  <div class="input-group">
                    <input type="text" v-model="additionalService.name['ru']" class="form-control">

                    <span class="input-group-btn">
                    <button v-on:click="updateAdditionalService(additionalService)" type="button" class="btn btn-info btn-flat">Save</button>
                  </span>
                  </div>
                </td>
                <td>{{additionalService.price.value}} {{additionalService.price.currency.codeISO}}</td>
                <td><a v-on:click="deleteAdditionalService(additionalService.id)"><i
                  class="text-red fa fa-times-circle-o"></i></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="box box-success">
          <div class="box-header">
            <h3 class="box-title">{{$t('trainings.additional-service.added-form.title')}}</h3>
          </div>
          <div class="box-body">
            <div v-if="!isBackoffice()" class="form-group">
              <label>{{$t('trainings.additional-service.added-form.name')}}</label>
              <input type="text" v-model="addedAdditionalService.name[$root.$i18n.locale]" class="form-control"
                     placeholder="">
            </div>

            <div v-if="isBackoffice()" class="form-group">
              <label>{{$t('trainings.additional-service.added-form.name')}} [en]</label>
              <input type="text" v-model="addedAdditionalService.name['en']" class="form-control"
                     placeholder="">
            </div>

            <div v-if="isBackoffice()" class="form-group">
              <label>{{$t('trainings.additional-service.added-form.name')}} [ru]</label>
              <input type="text" v-model="addedAdditionalService.name['ru']" class="form-control"
                     placeholder="">
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label>{{$t('trainings.additional-service.added-form.price')}}</label>
                    <input type="text" class="form-control" v-model="addedAdditionalService.price.value"
                           placeholder="">
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="form-group">
                    <label>{{$t('trainings.additional-service.added-form.currency')}}</label>
                    <select name="currency" class="form-control"
                            v-model="addedAdditionalService.price.currency">
                      <option value="RUB">RUB</option>
                      <option value="EUR">EUR</option>
                      <option value="USD">USD</option>
                      <option value="GBP">GBP</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <button type="submit" v-on:click="saveAdditionalService" class="btn btn-info pull-right">
              {{$t('button.save-changes')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TrainingAdditionalServices',
  props: {
    currentTraining: Object
  },
  data () {
    return {
      addedAdditionalService: {
        trainingId: '',
        name: {
          ru: '',
          en: ''
        },
        price: {
          value: 0,
          currency: ''
        },
        description: {
          ru: '',
          en: ''
        }
      }
    };
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    deleteAdditionalService (additionalServiceId) {
      // var del = {
      //   additionalServiceId: additionalServiceId,
      //   trainingId: this.currentTraining.id
      // };

      var self = this;

      // console.log(del);

      axios.delete(
        // window.rootRoute + '/api/trainings/additionalServices', {data: {additionalService: del}})
        window.host + '/trainings/' + self.currentTraining.id + '/additionalService/' + additionalServiceId)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', self.currentTraining.id);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    saveAdditionalService () {
      var self = this;

      self.addedAdditionalService.trainingId = self.currentTraining.id;

      axios.put(
        window.host + '/trainings/' + self.currentTraining.id + '/additionalService', self.addedAdditionalService)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateTraining', self.addedAdditionalService.trainingId);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    updateAdditionalService (additionalService) {
      var self = this;

      additionalService.trainingId = self.currentTraining.id;

      var savedAdditionalService = {
        name: additionalService.name,
        price: {
          value: additionalService.price.value,
          currency: additionalService.price.currency.codeISO
        },
        additionalServiceId: additionalService.id
      };

      axios.put(
        window.host + '/trainings/' + additionalService.trainingId + '/additionalService/update', savedAdditionalService)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>

<style scoped>

</style>
